import React from "react";

// Fin du questionnaire pour un allocataire orienté vers France Travail.
const LandingPE = () => {
  return (
    <div className="etat-final" role="status">
      <div>
        <img className="etat-final__logo" src="/assets/logo-pe.png" alt="France Travail" />
        <h2 className="etat-final__titre">Votre questionnaire est terminé</h2>
        <p>Un courrier concernant votre prochain rendez-vous va vous être adressé.</p>
        <p>
          <strong>
            Vous serez reçu(e) par un conseiller France Travail et poserez ensemble le cadre de votre
            accompagnement vers l'emploi.
          </strong>
        </p>
      </div>
    </div>
  );
};

export default LandingPE;
